__webpack_require__.p = "/brightbar/";